import VerticalLayout from '../layouts/VerticalLayout';
import HorizontalLayout from '../layouts/HorizontalLayout';
import CapabilitiesIcon from '../../icons/CapabilitiesIcon';
import { Chip } from '@opendoor/mosaic';
import { capitalCase } from '../../utils/string';
import ComingSoonEditButton from './ComingSoonEditButton';
import { GetVendorBranch_vendor_getVendorBranchByID_vendorBranch_capabilities } from '../../graphql/athena/types/GetVendorBranch';

interface CapabilitiesProps {
  capabilities?: GetVendorBranch_vendor_getVendorBranchByID_vendorBranch_capabilities[];
}

const Capabilities = ({ capabilities }: CapabilitiesProps) => {
  if (!capabilities) return null;
  return (
    <VerticalLayout
      style={{ width: 'calc(50% - 24px)', minWidth: 256 }}
      className="flex-auto h-8 pa-5 bg-white ma-4 bo-radius-2"
    >
      <HorizontalLayout className="justify-between items-center">
        <HorizontalLayout className="items-center">
          <CapabilitiesIcon />
          <h2 className="pl-4">Capabilities</h2>
        </HorizontalLayout>
        <ComingSoonEditButton />
      </HorizontalLayout>
      <HorizontalLayout className="flex-wrap">
        {capabilities.map((c) => (
          <Chip key={c.capabilityType} label={capitalCase(c.capabilityType)} className="mr-3" />
        ))}
      </HorizontalLayout>
    </VerticalLayout>
  );
};

export default Capabilities;
